import { render } from "./locale-button.vue?vue&type=template&id=1a619681&scoped=true"
import script from "./locale-button.vue?vue&type=script&lang=js"
export * from "./locale-button.vue?vue&type=script&lang=js"

import "./locale-button.vue?vue&type=style&index=0&id=1a619681&scoped=true&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/hkust-gz-vitals/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a619681"]])

export default __exports__